/* eslint-disable */
// @ts-nocheck
/**
 * @fileoverview gRPC-Web generated client stub for worklayer.internal.bookkeeping.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: internal/bookkeeping.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var google_api_field_behavior_pb = require('../google/api/field_behavior_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var shared_types_decimal_pb = require('../shared/types/decimal_pb.js')
const proto = {};
proto.worklayer = {};
proto.worklayer.internal = {};
proto.worklayer.internal.bookkeeping = {};
proto.worklayer.internal.bookkeeping.v1 = require('./bookkeeping_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>}
 */
const methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnection = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnection',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest,
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServiceClient.prototype.createXeroPlatformConnection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnection',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnection,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServicePromiseClient.prototype.createXeroPlatformConnection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnection',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse>}
 */
const methodDescriptor_XeroPlatformConnectionService_ListConnectedXeroAccounts = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/ListConnectedXeroAccounts',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest,
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServiceClient.prototype.listConnectedXeroAccounts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/ListConnectedXeroAccounts',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_ListConnectedXeroAccounts,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ListConnectedXeroAccountsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServicePromiseClient.prototype.listConnectedXeroAccounts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/ListConnectedXeroAccounts',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_ListConnectedXeroAccounts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>}
 */
const methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnectionFromOAuth2Code = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnectionFromOAuth2Code',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest,
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServiceClient.prototype.createXeroPlatformConnectionFromOAuth2Code =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnectionFromOAuth2Code',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnectionFromOAuth2Code,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionFromOAuth2CodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CreateXeroPlatformConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServicePromiseClient.prototype.createXeroPlatformConnectionFromOAuth2Code =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/CreateXeroPlatformConnectionFromOAuth2Code',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_CreateXeroPlatformConnectionFromOAuth2Code);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse>}
 */
const methodDescriptor_XeroPlatformConnectionService_GetConnectedXeroAccount = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/GetConnectedXeroAccount',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest,
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServiceClient.prototype.getConnectedXeroAccount =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/GetConnectedXeroAccount',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_GetConnectedXeroAccount,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.GetConnectedXeroAccountResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.XeroPlatformConnectionServicePromiseClient.prototype.getConnectedXeroAccount =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.XeroPlatformConnectionService/GetConnectedXeroAccount',
      request,
      metadata || {},
      methodDescriptor_XeroPlatformConnectionService_GetConnectedXeroAccount);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>}
 */
const methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnection = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnection',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest,
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServiceClient.prototype.createQuickBooksPlatformConnection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnection',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnection,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServicePromiseClient.prototype.createQuickBooksPlatformConnection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnection',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse>}
 */
const methodDescriptor_QuickBooksPlatformConnectionService_ListConnectedQuickBooksAccounts = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/ListConnectedQuickBooksAccounts',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest,
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServiceClient.prototype.listConnectedQuickBooksAccounts =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/ListConnectedQuickBooksAccounts',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_ListConnectedQuickBooksAccounts,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ListConnectedQuickBooksAccountsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServicePromiseClient.prototype.listConnectedQuickBooksAccounts =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/ListConnectedQuickBooksAccounts',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_ListConnectedQuickBooksAccounts);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>}
 */
const methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnectionFromOAuth2Code = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnectionFromOAuth2Code',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest,
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServiceClient.prototype.createQuickBooksPlatformConnectionFromOAuth2Code =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnectionFromOAuth2Code',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnectionFromOAuth2Code,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionFromOAuth2CodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CreateQuickBooksPlatformConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServicePromiseClient.prototype.createQuickBooksPlatformConnectionFromOAuth2Code =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/CreateQuickBooksPlatformConnectionFromOAuth2Code',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_CreateQuickBooksPlatformConnectionFromOAuth2Code);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse>}
 */
const methodDescriptor_QuickBooksPlatformConnectionService_GetConnectedQuickBooksAccountByRealmId = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/GetConnectedQuickBooksAccountByRealmId',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest,
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServiceClient.prototype.getConnectedQuickBooksAccountByRealmId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/GetConnectedQuickBooksAccountByRealmId',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_GetConnectedQuickBooksAccountByRealmId,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.GetConnectedQuickBooksAccountsByRealmIdResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionServicePromiseClient.prototype.getConnectedQuickBooksAccountByRealmId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.QuickBooksPlatformConnectionService/GetConnectedQuickBooksAccountByRealmId',
      request,
      metadata || {},
      methodDescriptor_QuickBooksPlatformConnectionService_GetConnectedQuickBooksAccountByRealmId);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse>}
 */
const methodDescriptor_BookkeepingService_GetBookkeepingProgressionInfo = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingProgressionInfo',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest,
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.getBookkeepingProgressionInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingProgressionInfo',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetBookkeepingProgressionInfo,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingProgressionInfoResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.getBookkeepingProgressionInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingProgressionInfo',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetBookkeepingProgressionInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.Assessment>}
 */
const methodDescriptor_BookkeepingService_GetAssessment = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetAssessment',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest,
  proto.worklayer.internal.bookkeeping.v1.Assessment,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.Assessment.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.Assessment)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.Assessment>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.getAssessment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetAssessment',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetAssessment,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.Assessment>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.getAssessment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetAssessment',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetAssessment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse>}
 */
const methodDescriptor_BookkeepingService_ProvidePlatformConnection = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/ProvidePlatformConnection',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest,
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.providePlatformConnection =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ProvidePlatformConnection',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ProvidePlatformConnection,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ProvidePlatformConnectionResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.providePlatformConnection =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ProvidePlatformConnection',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ProvidePlatformConnection);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse>}
 */
const methodDescriptor_BookkeepingService_MarkAccessAsGranted = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/MarkAccessAsGranted',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest,
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.markAccessAsGranted =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/MarkAccessAsGranted',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_MarkAccessAsGranted,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.MarkAccessAsGrantedResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.markAccessAsGranted =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/MarkAccessAsGranted',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_MarkAccessAsGranted);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse>}
 */
const methodDescriptor_BookkeepingService_ListBookkeepingPendingActions = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/ListBookkeepingPendingActions',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest,
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.listBookkeepingPendingActions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ListBookkeepingPendingActions',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ListBookkeepingPendingActions,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ListBookkeepingPendingActionsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.listBookkeepingPendingActions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ListBookkeepingPendingActions',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ListBookkeepingPendingActions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse>}
 */
const methodDescriptor_BookkeepingService_ConfirmManagedPlatformAccess = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmManagedPlatformAccess',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest,
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.confirmManagedPlatformAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmManagedPlatformAccess',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ConfirmManagedPlatformAccess,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ConfirmManagedPlatformAccessResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.confirmManagedPlatformAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmManagedPlatformAccess',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ConfirmManagedPlatformAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse>}
 */
const methodDescriptor_BookkeepingService_ConfirmUnmanagedPlatformAccess = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmUnmanagedPlatformAccess',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest,
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.confirmUnmanagedPlatformAccess =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmUnmanagedPlatformAccess',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ConfirmUnmanagedPlatformAccess,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.ConfirmUnmanagedPlatformAccessResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.confirmUnmanagedPlatformAccess =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/ConfirmUnmanagedPlatformAccess',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_ConfirmUnmanagedPlatformAccess);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse>}
 */
const methodDescriptor_BookkeepingService_SubmitBookkeepingAssessment = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/SubmitBookkeepingAssessment',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest,
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.submitBookkeepingAssessment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/SubmitBookkeepingAssessment',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_SubmitBookkeepingAssessment,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.SubmitBookkeepingAssessmentResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.submitBookkeepingAssessment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/SubmitBookkeepingAssessment',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_SubmitBookkeepingAssessment);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse>}
 */
const methodDescriptor_BookkeepingService_CompleteBookkeepingAssessmentReview = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingAssessmentReview',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest,
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.completeBookkeepingAssessmentReview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingAssessmentReview',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CompleteBookkeepingAssessmentReview,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingAssessmentReviewResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.completeBookkeepingAssessmentReview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingAssessmentReview',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CompleteBookkeepingAssessmentReview);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse>}
 */
const methodDescriptor_BookkeepingService_GetBookkeepingPendingActionAggregations = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingPendingActionAggregations',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest,
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.getBookkeepingPendingActionAggregations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingPendingActionAggregations',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetBookkeepingPendingActionAggregations,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.GetBookkeepingPendingActionAggregationsResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.getBookkeepingPendingActionAggregations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/GetBookkeepingPendingActionAggregations',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_GetBookkeepingPendingActionAggregations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse>}
 */
const methodDescriptor_BookkeepingService_StartNewBookkeepingCycle = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/StartNewBookkeepingCycle',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest,
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.startNewBookkeepingCycle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/StartNewBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_StartNewBookkeepingCycle,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.StartNewBookkeepingCycleResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.startNewBookkeepingCycle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/StartNewBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_StartNewBookkeepingCycle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse>}
 */
const methodDescriptor_BookkeepingService_CompleteBookkeepingCycle = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingCycle',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest,
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.completeBookkeepingCycle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CompleteBookkeepingCycle,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CompleteBookkeepingCycleResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.completeBookkeepingCycle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CompleteBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CompleteBookkeepingCycle);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest,
 *   !proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse>}
 */
const methodDescriptor_BookkeepingService_CorrectBookkeepingCycle = new grpc.web.MethodDescriptor(
  '/worklayer.internal.bookkeeping.v1.BookkeepingService/CorrectBookkeepingCycle',
  grpc.web.MethodType.UNARY,
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest,
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse,
  /**
   * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse.deserializeBinary
);


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServiceClient.prototype.correctBookkeepingCycle =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CorrectBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CorrectBookkeepingCycle,
      callback);
};


/**
 * @param {!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.worklayer.internal.bookkeeping.v1.CorrectBookkeepingCycleResponse>}
 *     Promise that resolves to the response
 */
proto.worklayer.internal.bookkeeping.v1.BookkeepingServicePromiseClient.prototype.correctBookkeepingCycle =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/worklayer.internal.bookkeeping.v1.BookkeepingService/CorrectBookkeepingCycle',
      request,
      metadata || {},
      methodDescriptor_BookkeepingService_CorrectBookkeepingCycle);
};


module.exports = proto.worklayer.internal.bookkeeping.v1;

